import { Avatar, Box, Checkbox, Container, createTheme, CssBaseline, Dialog, DialogActions, DialogContent, DialogContentText, DialogTitle, FormControlLabel, Grid, Link, MenuItem, Modal, TextField, ThemeProvider, Typography } from '@material-ui/core';
import MUIDataTable, { MUIDataTableOptions } from 'mui-datatables';
import React, { Fragment, useEffect, useState } from 'react';
import { Button, Col, Dropdown, Row } from 'react-bootstrap';
import { getHeaderForAxios, getUserData } from '../../common/getLocalStorageData';
import axios from 'axios';
import { FaRegEdit, FaRegTrashAlt, FaTrashAlt } from 'react-icons/fa';
import { useSelector } from 'react-redux';
import { IReduxStateData } from '../../interfaces/redux';
import { PROFILE_STOREADDRESS, SIDE_MENU_PROFILE } from '../../constant/menuAndProfile';

interface IAddressList {
    storeList: Array<any>;
    storeUsersList: Array<any>;
}
interface IData {
    index?: number;
    user?: string;
    store?: string;
    address?: string;
    status?: string;
    current_index?: number;
}
export const AddressList = (props: IAddressList) => {
    const [storeList, setStoreList] = useState<Array<any>>([]);
    const [results, setResults] = useState<IData[]>([]);
    const [finalData, setFinalData] = useState<(string | number | undefined)[][]>([]);
    const [addressFlag, setAddressFlag] = useState(false)

    const [editing, setEditing] = useState(false);
    const [open, setOpen] = useState(false);
    const [addrInput, setAddrInput] = useState("")
    const [address2, setAddress2] = useState("");
    const [updateAddressIndex, setUpdateAddressIndex] = useState<number>(-1)
    const [currentAddress, setCurrentAddress] = useState<any>({})
    const [selectedStoreFromList, setSelectedStoreFromList] = useState<string>("")
    const [responseMessage, setResponseMessage] = useState({
        "message": "",
        "type": ""
    })
    const globalState = useSelector((state: IReduxStateData) => state);
    const selectedLanguage = globalState?.selectedLang;
    useEffect(() => {
        if (props?.storeList) {
            setStoreList(props?.storeList)
            // setEditing(true)
        }
    }, [props?.storeList])

    const onChangeFunction = () => {
        let data = updateAddressIndex !== -1 ? { ...storeList[updateAddressIndex] } : {};
        Object.keys(currentAddress).map((key) => {
            data[key] = currentAddress[key];
        })
        onSubmitAddress(data)
    }

    const resetDataRelatedToAddress = () => {
        setOpen(false);
        setEditing(false);
        setTimeout(() => {
            setAddrInput("")
            setAddress2("")
            setUpdateAddressIndex(-1)
            setCurrentAddress({})
            setSelectedStoreFromList("")
        }, 10);
    }

    const initMap = () => {
        const input: any = document.getElementById("pac-input");
        if (input) {
            const options = {
                // componentRestrictions: { country: "us" },
                fields: ["business_status", "geometry", "name", "formatted_address", "place_id", "address_components"],
                strictBounds: true,
                types: ["establishment"]
            };
            const autocomplete = new google.maps.places.Autocomplete(input, options);
            //autocomplete.setFields(["place_id", "geometry", "name"]);
            autocomplete.addListener("place_changed", () => {
                console.log("place_changed")
                const place: any = autocomplete.getPlace();
                let address1 = "";
                let postalcode = "";
                let city = "";
                let state = "";
                let country = "";
                for (const component of place.address_components) {
                    const componentType = component.types[0];

                    switch (componentType) {
                        case "street_number": {
                            address1 = `${component.long_name} ${address1}`;
                            break;
                        }

                        case "route": {
                            address1 += component.short_name;
                            break;
                        }

                        case "postal_code": {
                            postalcode = `${component.long_name}${postalcode}`;
                            break;
                        }

                        case "postal_code_suffix": {
                            postalcode = `${postalcode}-${component.long_name}`;
                            break;
                        }
                        case "locality":
                            city = component.long_name;
                            break;
                        case "administrative_area_level_1": {
                            state = component.short_name;
                            break;
                        }
                        case "country":
                            country = component.long_name;
                            break;
                    }
                }

                // address1Field.value = address1;
                // postalField.value = postcode;
                if (!address1) {
                    address1 = place['formatted_address']
                }
                setCurrentAddress({
                    "place_id": place['place_id'],
                    "name": place['name'],
                    "address1": address1,
                    "address2": address2,
                    "city": city,
                    "state": state,
                    "postalcode": postalcode,
                    "country": country,
                    "business_status": place['business_status'],
                    "geometry": { lat: place.geometry.location.lat(), lng: place.geometry.location.lng() }
                })
                setAddrInput(place['name'] + " " + address1);
                setAddressFlag(!addressFlag);
                // input.value = address1;
                console.log("kel", place.geometry.location.lat(), place.geometry.location.lng(), place, address1, ",..", postalcode)
            });
        }
    }
    let onSubmitAddress = async (dataInfo: any) => {
        let user_id = getUserData()
        if (user_id && Object.keys(dataInfo).length && dataInfo['place_id'] && dataInfo['name'] && dataInfo['business_status'] && dataInfo['address1']) {
            let data: any = {
                "user_uuid": user_id,
                "place_id": dataInfo['place_id'],
                "name": dataInfo['name'],
                "business_status": dataInfo['business_status'],
                "address1": dataInfo['address1'],
                "postalcode": dataInfo['postalcode'],
                "country": dataInfo['country'],
                "geometry": dataInfo['geometry'],
                "address_id": dataInfo['address_id']
            }
            if (dataInfo['city']) {
                data['city'] = dataInfo['city'];
            }
            if (dataInfo['state']) {
                data['state'] = dataInfo['state'];
            }
            if (dataInfo['id']) {
                data['id'] = dataInfo['id'];
            }
            if (dataInfo['address2']) {
                data['address2'] = dataInfo['address2'];
            }
            if (dataInfo['store_uuid']) {
                data['store_uuid'] = dataInfo['store_uuid'];
            } else if (selectedStoreFromList) {
                data['store_uuid'] = selectedStoreFromList;
            }
            await axios.post(process.env.REACT_APP_API_URL + "/sponsor/addUpdateStoreSponsorAddress", data, { headers: getHeaderForAxios() })
                .then(function (response) {
                    // handle success
                    if (response.data && response.data.status) {
                        if (data['id']) {
                            const listOfData = storeList.map((pData, pIndex) => {
                                if (pData.id === data['id'] && pIndex === updateAddressIndex) {
                                    // storePropsData[pIndex] = data;
                                    // props.changeStoreData(storePropsData);
                                    // resetAddress()
                                    return data;
                                } else {
                                    return pData;
                                }
                            })
                            setStoreList(listOfData)
                        } else {
                            // storePropsData.push(data)
                            // props.changeStoreData(storePropsData);
                            // resetAddress()
                            if (response.data.success) {
                                const listOfData = [...storeList];
                                listOfData.push({ ...data, ...response.data.success });
                                setStoreList(listOfData)
                            }
                        }
                        resetDataRelatedToAddress()
                        if (response.data?.message) {
                            setResponseMessage({ message: response.data?.message, type: "success" });
                            setTimeout(() => {
                                setResponseMessage({ message: "", type: "" });
                            }, 10000);
                        }
                    }
                })
                .catch(function (error) {
                    // handle error
                    console.log(error);
                    if (error?.response?.data?.message) {
                        resetDataRelatedToAddress()
                        setResponseMessage({ message: error.response.data.message, type: "error" });
                        setTimeout(() => {
                            setResponseMessage({ message: "", type: "" });
                        }, 10000);
                    }
                })
        }
    }
    let onDeleteAddress = async (data: any, addressIndex: number) => {
        let user_id = getUserData()
        if (user_id && data.id) {
            let finalData = { "id": data.id, "user_uuid": user_id, "status": 2, "address_id": data.address_id }
            await axios.post(process.env.REACT_APP_API_URL + "/sponsor/addUpdateStoreSponsorAddress", finalData, { headers: getHeaderForAxios() })
                .then(function (response) {
                    // handle success
                    if (response.data && response.data.status) {
                        // props.refreshData()
                        let data = [...storeList];
                        data.splice(addressIndex, 1);
                        setStoreList(data);
                        if (response.data?.message) {
                            setResponseMessage({ message: response.data?.message, type: "success" });
                            setTimeout(() => {
                                setResponseMessage({ message: "", type: "" });
                            }, 10000);
                        }
                    }
                })
                .catch(function (error) {
                    // handle error
                    if (error?.response?.data?.message) {
                        setResponseMessage({ message: error.response.data.message, type: "error" });
                        setTimeout(() => {
                            setResponseMessage({ message: "", type: "" });
                        }, 10000);
                    }
                })
        }
    }

    let approveStore = async (data: any) => {
        let user_id = getUserData()
        if (user_id && data.id) {
            let finalData = { "id": data.id, "user_uuid": user_id, "status": 1, "address_id": data.address_id }
            await axios.post(process.env.REACT_APP_API_URL + "/sponsor/addUpdateStoreSponsorAddress", finalData, { headers: getHeaderForAxios() })
                .then(function (response) {
                    // handle success
                    if (response.data && response.data.status) {
                        // props.refreshData()
                    }
                })
                .catch(function (error) {
                    // handle error
                    console.log(error);
                    if (error?.response?.data?.message) {
                        setResponseMessage({ message: error.response.data.message, type: "error" });
                        setTimeout(() => {
                            setResponseMessage({ message: "", type: "" });
                        }, 10000);
                    }
                })
        }
    }
    const columns = [
        { name: PROFILE_STOREADDRESS[selectedLanguage].no, options: { filter: false, fullWidth: true } },
        {
            name: PROFILE_STOREADDRESS[selectedLanguage].user, options: {
                filter: true,
                customBodyRender: (value: any, tableMeta: { rowData: any; }, updateValue: any) => {
                    return (
                        <Fragment>
                            {value ?
                                <p>{value}</p>
                                :
                                // <p onClick={() => {
                                // }}
                                //     className="button muted-button pointer"
                                // >Assign Store</p>
                                ""
                            }
                        </Fragment>
                    );
                }
            }
        },
        { name: PROFILE_STOREADDRESS[selectedLanguage].store, options: { filter: true } },
        { name: PROFILE_STOREADDRESS[selectedLanguage].address, options: { filter: true } },
        { name: PROFILE_STOREADDRESS[selectedLanguage].status, options: { filter: true } },
        {
            name: PROFILE_STOREADDRESS[selectedLanguage].action,
            options: {
                filter: false,
                customBodyRender: (value: any, tableMeta: { rowData: any; }, updateValue: any) => {
                    return (
                        <Fragment>
                            <FaRegEdit className="mr-3 theme-green font-16 pointer" onClick={() => {
                                setUpdateAddressIndex(value)
                                setCurrentAddress(storeList[value])
                                if (storeList[value] && storeList[value]?.name) {
                                    setAddrInput(storeList[value]?.name + " " + storeList[value]?.address1)
                                }
                                if (storeList[value] && storeList[value]?.store_uuid) {
                                    setSelectedStoreFromList(storeList[value].store_uuid)
                                }
                                setOpen(true);
                                setEditing(true);
                            }} />
                            <FaTrashAlt className="text-gray font-16 pointer" onClick={() => {
                                if (storeList[value]) {
                                    onDeleteAddress(storeList[value], value)
                                }
                            }} />
                        </Fragment>
                    );
                }
            }
        }
    ];
    const options: MUIDataTableOptions = {
        filter: true,
        filterType: "dropdown",
        responsive: 'simple',
        jumpToPage: false,
        fixedSelectColumn: false,
        fixedHeader: false,
        pagination: false,
        selectableRows: 'none',
        onTableChange: (action, state) => {
            // console.log(action);
            // console.dir(state);
        }
    };
    useEffect(() => {
        if (storeList) {
            let data: any[] = [];
            let array: (string | number | undefined)[][];
            storeList?.map((storeData: any, index: number) => {
                let addressDetail = storeData?.address1;
                if (storeData?.city) {
                    addressDetail += ", " + storeData?.city;
                }
                if (storeData?.state) {
                    addressDetail += ", " + storeData?.state;
                }
                if (storeData?.country) {
                    addressDetail += ", " + storeData?.country;
                }
                data.push({
                    index: index + 1,
                    user: storeData?.store_name,
                    store: storeData?.name,
                    address: addressDetail,
                    status: storeData?.business_status,
                    current_index: index
                })
            })
            setResults(data)
            if (data) {
                if (data.length) {
                    array = data?.map(result => [result.index, result.user, result.store || "-", result.address || '-', result?.status || '-', result?.current_index]);
                    // data = array;
                    setFinalData(array)
                }
            }
        }
    }, [storeList])

    useEffect(() => {
        if (editing) {
            setTimeout(() => {
                initMap()
            }, 50);
        }
    }, [editing])

    const handleClose = () => {
        resetDataRelatedToAddress();
    }
    return (
        <Fragment>
            {/* {editing ? */}
            <Dialog
                open={open}
                onClose={handleClose}
                fullWidth
                maxWidth="sm"
            >
                <DialogTitle className='d-flex align-self-center justify-content-center'>{Object.keys(currentAddress).length && currentAddress?.address_id ? PROFILE_STOREADDRESS[selectedLanguage].dialog_edit_title : PROFILE_STOREADDRESS[selectedLanguage].dialog_add_title}</DialogTitle>
                <DialogContent key={addressFlag ? "true" : "false"}>
                    <Row className='py-2 mx-3 mx-md-5'>
                        <Col sm={12} className=''>
                            <Row>
                                <TextField
                                    style={{ marginTop: 20 }}
                                    label={PROFILE_STOREADDRESS[selectedLanguage].dialog_store_name}
                                    select
                                    fullWidth
                                    variant="outlined"
                                    value={selectedStoreFromList}
                                    id="pac-store"
                                    margin="dense"
                                    onChange={(e) => { setSelectedStoreFromList(e.target.value) }}
                                >
                                    <MenuItem value="" selected={selectedStoreFromList === "" ? true : false}>Please select store</MenuItem>
                                    {props?.storeUsersList?.map((option: any, index) => (
                                        <MenuItem key={option.name + "-" + index} value={option.store_uuid}>
                                            {option.name}
                                        </MenuItem>
                                    ))}
                                </TextField>
                            </Row>
                            <Row>
                                <TextField
                                    fullWidth
                                    margin="dense"
                                    variant="outlined"
                                    label={PROFILE_STOREADDRESS[selectedLanguage].dialog_store_location}
                                    id="pac-input"
                                    onChange={(e) => { setAddrInput(e.target.value) }}
                                    value={addrInput}
                                // focused
                                />
                            </Row>
                            <Row>
                                <TextField
                                    fullWidth
                                    margin="dense"
                                    variant="outlined"
                                    label={PROFILE_STOREADDRESS[selectedLanguage].dialog_store_locality}
                                    id="pac-apartment"
                                    value={address2}
                                    defaultValue={address2}
                                    onChange={(e) => setAddress2(e.target.value)}
                                />
                            </Row>
                            <Row>
                                <TextField
                                    fullWidth
                                    margin="dense"
                                    variant="outlined"
                                    label={PROFILE_STOREADDRESS[selectedLanguage].dialog_store_city}
                                    id="pac-city"
                                    value={currentAddress?.city}
                                    defaultValue={currentAddress?.city}
                                    disabled
                                // onChange={(e) => setAddrInput(e.target.value)}
                                />
                            </Row>
                            <Row>
                                <Col className='pl-0 pr-1 pr-md-3'>
                                    <TextField
                                        margin="dense"
                                        variant="outlined"
                                        label={PROFILE_STOREADDRESS[selectedLanguage].dialog_store_state}
                                        id="pac-state"
                                        value={currentAddress?.state}
                                        defaultValue={currentAddress?.state}
                                        disabled
                                    // className='pr-1'
                                    // onChange={(e) => setAddrInput(e.target.value)}
                                    />
                                </Col>
                                <Col className='pr-0 pl-1 pl-md-3'>
                                    <TextField
                                        // className='pl-1'
                                        margin="dense"
                                        variant="outlined"
                                        label={PROFILE_STOREADDRESS[selectedLanguage].dialog_store_postal_code}
                                        id="pac-postal"
                                        value={currentAddress?.postalcode}
                                        defaultValue={currentAddress?.postalcode}
                                        disabled
                                    // onChange={(e) => setAddrInput(e.target.value)}
                                    />
                                </Col>
                            </Row>
                            <Row>
                                <TextField
                                    fullWidth
                                    margin="dense"
                                    variant="outlined"
                                    label={PROFILE_STOREADDRESS[selectedLanguage].dialog_store_country}
                                    id="pac-country"
                                    value={currentAddress?.country}
                                    defaultValue={currentAddress?.country}
                                    disabled
                                // onChange={(e) => setAddrInput(e.target.value)}
                                />
                            </Row>
                            {/* <input id="pac-input" className="controls" type="text" placeholder="Enter a location" onChange={(e) => setAddrInput(e.target.value)} /> */}
                            {/* <DialogContentText>
                                    Edit Address
                                </DialogContentText> */}
                        </Col>
                    </Row>
                </DialogContent>
                <DialogActions>
                    <Row className='mx-5 mb-2 w-100 d-flex align-self-center justify-content-center'>
                        <Button onClick={onChangeFunction}
                            variant="dark" className='py-1 rounded-sm' autoFocus>
                            {SIDE_MENU_PROFILE[selectedLanguage].save}
                        </Button>
                        <Button onClick={handleClose}
                            variant="primary" className='ml-2 py-1 rounded-sm' autoFocus>
                            {SIDE_MENU_PROFILE[selectedLanguage].close}
                        </Button>
                    </Row>
                </DialogActions>
            </Dialog>
            {/* : null} */}
            <div className='right-side-header-main'>
                <div className='right-side-header'>{PROFILE_STOREADDRESS[selectedLanguage].address_list}</div>
            </div>
            <hr />
            <Row className='d-flex align-self-center justify-content-end'>
                {/* <button className="btn theme-background-dark-black theme-white "> Add Address</button> */}
                <Button variant="dark theme-background-dark-black theme-white rounded-sm py-2 font-16" onClick={() => {
                    resetDataRelatedToAddress();
                    setOpen(true);
                    setEditing(true);
                }}>{PROFILE_STOREADDRESS[selectedLanguage].add_address}</Button>
            </Row>
            {responseMessage.message ? (
                <div className='login-form-div'>
                    <div
                        className={
                            responseMessage.type === "success"
                                ? "form-response success mb-0 mt-2"
                                : "form-response error mb-0 mt-2"
                        }
                    >
                        {responseMessage.message}
                    </div>
                </div>
            ) : null}
            <Row className='pt-2'>
                <Col sm={12} className='react-table-kitchen-wrapper theme-dark-black'>
                    <div className="table-wrapper" style={{ 'flexGrow': 1 }}>
                        {finalData ?
                            // <ThemeProvider theme={createTheme()}>
                            <MUIDataTable
                                title={""}
                                data={finalData}
                                columns={columns}
                                options={options}
                            />
                            // </ThemeProvider>
                            : null
                        }
                    </div>
                </Col>
            </Row>
        </Fragment>
    )
}
